const videos = document.querySelectorAll('[data-video-id]');
if (videos) {
    for (const video of videos) {
        const {id, thumbnail, showUrl} = video.dataset;
        if (id) {
            const endpoint = 'https://www.googleapis.com/youtube/v3/videos';
            axios.get(endpoint, {
                params: {
                    key: googleKey,
                    part: 'snippet',
                    id
                }
            })
                .then((r) => {
                    const code = [];
                    if (r.data.items.length > 0) {
                        const tb = r.data.items[0].snippet.thumbnails.high;
                        code.push(`<a href="${showUrl}"><img src="${tb.url}" width="${tb.width}" height="${tb.height}" class="img-fluid"></a>`);
                    } else {
                        code.push(`<a href="${showUrl}"><img src="${thumbnail}" class="img-fluid"></a>`);
                    }
                    video.innerHTML = code.join('');
                })
                .catch((err) => {
                    console.log(err.response ? err.response : (err.request ? err.request : err));
                    const code = `<a href="${showUrl}"><img src="/images/no-thumbnail-default.png" width="640" height="480" class="img-fluid"></a>`;
                    video.innerHTML = code;
                });
        }
    }
}

// public 글쓰기 모드
const publicEditor = document.getElementById('editor-content');
if (publicEditor) {
    tinymce.init({
        selector: 'textarea#editor-content',
        menubar: false,
        language: 'ko_KR',
        plugins: 'print preview paste importcss searchreplace autolink autosave autoresize save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap emoticons',
        toolbar_sticky: true,
        toolbar: 'bold italic | alignleft aligncenter alignright alignjustify | numlist bullist | forecolor backcolor removeformat | charmap emoticons link | code',
        autoresize_bottom_margin: 50,
        branding: false,
        min_height: 500,
        directionality: 'ltr'
    });
}

// public post 삭제
const destroyPostForm = document.getElementById('destroyPostForm');
if (destroyPostForm) {
    destroyPostForm.addEventListener('submit', e => {
        e.preventDefault();
        if (!confirm('이 글을 삭제할까요?')) return false;

        axios.delete(e.target.action)
            .then( r => {
                alert('삭제되었습니다.');
                let pageNo = 'page=1';
                const pageNoArr = location.search.match(/(&page=[\d]+)/gi);
                if (pageNoArr && pageNoArr.length > 0) {
                    pageNo = pageNoArr[0].replace(/&/, '');
                }

                location.href = `${location.origin + location.pathname}?${pageNo}`;
            })
            .catch(err=>{
                console.log(err.response ? err.response : (err.request ? err.request : err));
                alert('삭제 오류 발생 : 관리자에게 문의바랍니다.');
            });
    });
}

const publicPostForm = document.getElementById('publicForm');
if (publicPostForm) {
    publicPostForm.addEventListener('submit', e => {
        e.preventDefault();
        const f = e.target;
        Array.from(f.querySelectorAll('.is-invalid, .invalid-feedback'))
            .map(el=>{
                if (el.classList.contains('is-invalid')) {
                    el.classList.remove('is-invalid');
                } else if (el.classList.contains('invalid-feedback')) {
                    el.innerText = '';
                }
            });

        const submitBtnEl = f.querySelector('button[type="submit"]');
        submitBtnEl.innerText = '저장 중...';
        submitBtnEl.setAttribute('disabled', true);
        const fd = new FormData(f);
        fd.append('content', tinymce.activeEditor.getContent());

        axios.post(e.target.action, fd)
            .then(r=>{
                console.log(r.data);
                submitBtnEl.innerText = '저장 완료!';
                const {id, redirectTo} = r.data;
                location.href = redirectTo ?? `${location.origin}${location.pathname}?mode=show&pid=${id}`;

            })
            .catch(err=>{
                console.log(err.response ? err.response : err);
                if (err.response && err.response.status === 422) {
                    const {errors} = err.response.data;
                    const keys = Object.keys(errors);
                    for(let key of Object.keys(errors)) {
                        const msg = errors[key][0];
                        let item = f.querySelector(`[name="${key}"]`);
                        if ( key === 'attached') {
                            item = f.querySelector('[name="attached[]"]');
                        }

                        if (item) {
                            const feedback = item.closest('.form-group').querySelector('.invalid-feedback');
                            feedback.textContent = msg;
                            item.classList.add('is-invalid');
                        }
                    }
                } else {
                    showAlert('오류', '저장 중 오류 발생! 관리자에게 문의바랍니다.');
                }

                submitBtnEl.innerText = '저장하기';
                submitBtnEl.setAttribute('disabled', false);
            });
    });
}

const attachedFileDelTrigger = document.getElementById('attached_file_del_trigger');
if (attachedFileDelTrigger) {
    attachedFileDelTrigger.addEventListener('click', e=>{
        const container = document.getElementById('attached_files');
        const checkedFiles = container.querySelectorAll('input[type="checkbox"]:checked');
        if ( checkedFiles.length === 0 ) {
            alert('삭제할 파일을 선택하세요.');
            return false;
        }

        if ( !confirm(`${checkedFiles.length}개의 파일을 삭제하시겠습니까?`) ) return false;

        Array.from(checkedFiles).map(el=>{
            const d = {
                post_id: el.dataset.postId,
                attached_id: el.value
            }

            axios.delete('/api/attached/destroy', {
                params: d
            })
                .then(r=>{
                    console.log(r);
                    removeFadeOut(el.closest('li'));
                })
                .catch(err=>{
                    console.log(err.response ? err.response : err);
                    el.classList.add('is-invalid');
                })
        });
    });
}
